module.exports = __webpack_public_path__ + "vue-assets/img/left-chevron.31c1a315.svg";